import avatar1 from './img/avata.jpg';

const data = [
    {
        id: 1,
        name: 'Lorem Ipsum',
        image: avatar1,
        currency: '500.6 ETH'
    },
    {
        id: 2,
        name: 'Jane Doe',
        image: avatar1,
        currency: '500.6 ETH'
    },
    {
        id: 3,
        name: 'John Doe',
        image: avatar1,
        currency: '500.6 ETH'
    },
    {
        id: 4,
        name: 'Sarah Doe',
        image: avatar1,
        currency: '500.6 ETH'
    }
]

export default data;